import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.23_@babel+core@7.29.7_supports-color@7.2.0__react-dom@19.2.8_react@19.2.8__react@19.2.8_sass@1.102.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.23_@babel+core@7.29.7_supports-color@7.2.0__react-dom@19.2.8_react@19.2.8__react@19.2.8_sass@1.102.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Headers/LinkBluKai.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RenewalReminder/RenewalReminder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/Home/Categories.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/Home/HomeSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/sass/modules/_home2.scss");
